import React, { FC, useMemo } from 'react';
import filter from 'lodash/filter';

import NodeSelector from 'src/presentation/components/pages/ivr/components/NodeSelector';
import { NodeProps } from 'src/presentation/components/pages/ivr/constants/ivrConstants';
import { Row } from 'src/presentation/components/pages/ivr/layouts/IvrLayout';

const StartNode: FC<NodeProps> = ({ attr, disabled, nodeList, onSelectNode, readOnly }) => {
  const options = useMemo(() => filter(nodeList, node => !!node.value), [nodeList]);

  return (
    <Row>
      <NodeSelector
        searchable
        allowEmptyValues={false}
        attr={attr}
        data-aid={attr}
        description="The next node in the IVR"
        disabled={disabled}
        label="Next Node"
        omittedNodeIds={[]}
        onSelectNode={onSelectNode}
        options={options}
        readOnly={readOnly}
      />
    </Row>
  );
};

export default StartNode;
